import { render, staticRenderFns } from "./ServiceIcon.vue?vue&type=template&id=3c45fea6&"
import script from "./ServiceIcon.vue?vue&type=script&lang=ts&"
export * from "./ServiceIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports